<template>
  <v-list-item v-if="type === 'list'" @click="downloadRechnung()">
    <v-list-item-icon><v-icon>download</v-icon></v-list-item-icon>
    <v-list-item-title>Rechnung herunterladen</v-list-item-title>
  </v-list-item>
  <v-tooltip bottom v-else>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :loading="loading" rounded text :icon="small" @click="downloadRechnung()">
        <v-icon v-if="icon">{{ icon }}</v-icon>
        <span v-if="text">{{ text }}</span>
      </v-btn>
    </template>
    <span>Rechnung herunterladen</span>
  </v-tooltip>
</template>

<script>
  import { generatePDFRechnungToLink } from "@/funktionen/generatePDFRechnungToLink.js";
  export default {
    props: ["small", "icon", "text", "rechnung", "type"],
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      //
    },
    methods: {
      async downloadRechnung() {
        this.loading = true;
        const rechnung = this.rechnung;
        try {
          let url;
          const kasse = this.$store.getters["einstellungen/einstellung"]("kassen")[rechnung.kasse];
          const year = rechnung.rechnungsnummer.split("-")[0];
          const storagePath = `rechnungen/${this.$vars.verbindung}/${year}/${rechnung.rechnungsnummer}`;
          const file = await this.$firebase.functions().httpsCallable("existsPDF")({
            path: storagePath,
            rechnung,
            kasse,
            verein: this.$vars.verbindung,
          });
          if (file.data) {
            url = file.data.url;
          } else {
            const bbr = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
            const settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
            url = await generatePDFRechnungToLink(rechnung, kasse, bbr, settings, this.$vars.verbindung);
          }
          console.log(url);
          var link = document.createElement("a");
          link.setAttribute("href", url);
          link.setAttribute("download", `${rechnung.rechnungsnummer}.pdf`);
          link.setAttribute("target", "_blank");
          link.setAttribute("rel", "noopener noreferrer");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.log(error);
        }
        this.loading = false;
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// rechnungDownload.vue?67e3d040